import studentRequest from 'utils/studentRequest'
import corporateRequest from 'utils/corporateRequest'
import { clearLocalStorageAndCookies } from '../../utils/helpers'


export const setAppliedRoleList = data => {
  return {
    type: 'SET_APPLIED_ROLE_LIST',
    data,
  }
}
export const setAppliedRoleMetrics = data => {
  return {
    type: 'SET_APPLIED_ROLE_METRICS',
    data,
  }
}

export const setViewRoleData = data => {
  return {
    type: 'SET_VIEW_ROLE_DATA',
    data,
  }
}
export const setNewRoleCount = data => {
  return {
    type: 'SET_NEW_ROLE_COUNT',
    data,
  }
}

export const getAppliedRoleList =
  ({ search, filter, page, setLoading }) =>
  async (dispatch, getState) => {
    setLoading(true)

    let searchKey = search ? `&search=${search}` : ''
    let filterKey = filter ? `&filter=${filter}` : ''
    let pageKey = `&currentPage=${page}`

    const state1 = getState()
    try {
      const res = await studentRequest.get(
        `/students/roles/applied/list/${state1?.auth?.studentId}?pageLimit=10${searchKey}${filterKey}${pageKey}`
      )
      dispatch(setAppliedRoleList(res?.data?.data))
      setLoading(false)
    } catch (error) {
      console.log('Error in Getting Jobs list', error)
    }
  }

export const getAppliedRoleMetrics = () => async (dispatch, getState) => {
  const state1 = getState()
  try {
    const res = await studentRequest.get(
      `/students/roles/${state1?.auth?.studentId}/metrics`
    )
    dispatch(setAppliedRoleMetrics(res?.data?.data))
  } catch (error) {
    const { AUTH_URL } = process.env

    console.log('Error in Getting Jobs list', error)
    if (error?.response?.status === 401) {
      clearLocalStorageAndCookies()
      window.location.replace(AUTH_URL || '/auth')
    }
  }
}


export const getNewRoleMetrics = () => async (dispatch, getState) => {
  const state1 = getState()
  let payload = {
    "count":true
  }

  try {
    const res = await corporateRequest.put(
      `/corporates/roleMetrics/${state1?.auth?.studentId}/count`,payload
    )
    console.log(res?.data?.data,'getNewRoleMetrics')
    dispatch(setNewRoleCount(res?.data?.data))
  } catch (error) {
    const { AUTH_URL } = process.env

    console.log('Error in Getting Jobs list', error)
    if (error?.response?.status === 401) {
      clearLocalStorageAndCookies()
      window.location.replace(AUTH_URL || '/auth')
    }
  }
}
